export const isLandscape = () => window.innerWidth > window.innerHeight;
